// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"185":"0a55c8ea991ff9f7","773":"9733c87d184c56b7"}[chunkId] + ".css";
};